import React from 'react';
import { TextInput, SelectInput, required, useTranslate, useLocaleState } from 'react-admin';
import { RichTextInput, RichTextInputToolbar } from 'ra-input-rich-text';
import { DRESS_CODES, COUPLES_RULES } from '../../../constants/events';
import InputRow from '../InputRow';
import { SourceLanguageBanner } from '../SourceLanguageBanner';
import { useSourceLanguage } from '../../../hooks/useSourceLanguage';

/**
 * Event More Details Tab Component
 * Tek kaynak dil alanı — DeepL diğer dillere çevirir.
 */
export const EventMoreDetailsTab = ({ isEdit = false, record = {} }) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  const { localizedSource } = useSourceLanguage({ isEdit, record });

  const translatedDressCodes = React.useMemo(
    () =>
      DRESS_CODES.map((item) => ({
        ...item,
        name: translate(`form.dress_code_${item.id}`, { _: item.name }),
      })),
    [translate, locale],
  );

  const translatedCouplesRules = React.useMemo(
    () =>
      COUPLES_RULES.map((item) => ({
        ...item,
        name: translate(`form.couples_rule_${item.id}`, { _: item.name }),
      })),
    [translate, locale],
  );

  return (
    <React.Fragment>
      <SourceLanguageBanner isEdit={isEdit} record={record} />

      <h3>
        {translate('form.event_description', { _: 'Event Description' })}{' '}
        <span style={{ color: 'orange', fontStyle: 'italic', fontSize: 12 }}>
          ({translate('form.required_mark', { _: '*required' })})
        </span>
      </h3>

      <RichTextInput
        source={localizedSource('description')}
        label={translate('form.description', { _: 'Description' })}
        validate={required()}
        fullWidth
        toolbar={<RichTextInputToolbar size="small" />}
      />

      <h3>{translate('form.event_rules', { _: 'Event Rules' })}</h3>

      <h4>
        {translate('form.things_to_know', { _: 'Things to know' })}{' '}
        <span style={{ color: 'orange', fontStyle: 'italic', fontSize: 12 }}>
          ({translate('form.required_mark', { _: '*required' })})
        </span>
      </h4>

      <RichTextInput
        source={localizedSource('details')}
        label={translate('form.event_rules', 'Event Rules')}
        validate={required()}
        fullWidth
        toolbar={<RichTextInputToolbar size="small" />}
      />

      <h4>{translate('form.rule_chips', 'Rule Chips')}</h4>
      <span
        style={{
          backgroundColor: '#0ABAB5',
          color: 'white',
          borderRadius: 10,
          fontSize: 12.5,
          padding: 5,
          marginTop: -10,
          marginBottom: 8,
          display: 'inline-block',
        }}
      >
        {translate('form.rule_chips_hint', "Rules that are left empty won't appear on the front-end website.")}
      </span>

      <TextInput source="rules.age" label={translate('form.age_rule', 'Age Rule')} fullWidth defaultValue={null} />

      <InputRow>
        <SelectInput
          source="rules.dress"
          label={translate('form.dress_code', 'Kıyafet Kuralı')}
          choices={translatedDressCodes}
          fullWidth
          defaultValue={[]}
        />
        <SelectInput
          source="rules.couples"
          label={translate('form.couples_rule', 'Damsız Girilmez / Kuralı')}
          choices={translatedCouplesRules}
          fullWidth
          defaultValue={[]}
        />
      </InputRow>
    </React.Fragment>
  );
};
